module.exports = __webpack_public_path__ + "static/media/light-logo.ad1a8eb0.svg";